import CropperImage from './index.vue'

/* istanbul ignore next */
CropperImage.install = function(Vue) {
  Vue.component(CropperImage.name, CropperImage)
}

export default CropperImage
